import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {getTranslation} from "../../../helpers/get-translation";

const styles = theme => ({
	topLogo: {
		marginBottom: "10vh",
		flex: '1 0 auto',
		height: "150px",
		"& img":{
			height: "100%",
			width: "auto",
		},
		"@media (max-width: 600px)": {
			height: "100px",
		},
		"@media (max-height: 700px)": {
			height: "100px",
			marginBottom: "12vh !important"
		},
	},
	doubleTopLogo:{
		background: `url("${getTranslation("image_main_top_background")}")`,
		backgroundSize: "contain",
		textAlign: "center"
	},
	"@media (max-height: 700px) and (min-width: 768px)": {
		topLogo: {
			marginBottom: "0"
		}
	},
});

function TopLogo(props) {
	const { classes } = props;

	const logoClass = getTranslation("image_main_top_background") !== "" ?
		[classes.topLogo, classes.doubleTopLogo].join(" ") :
		classes.topLogo;

		return (
			<div className={logoClass}>
				<img src={getTranslation("image_main_top_banner")} alt="Logo quiz"/>
			</div>
		);
}

TopLogo.propTypes = {
	classes: PropTypes.shape({
	}).isRequired,
};

export default withStyles(styles)(TopLogo);
